<template>
<atlas :artists="artists" v-if="artists"></atlas>
</template>

<script>
import Vue from 'vue'

export default Vue.component('RouteAtlas', {
  computed: {
    artists() {
      return this.$store.getters['artists/artists']
    }
  }
})
</script>

<style scoped lang="scss">
@import '~@/_variables.scss';
</style>



// WEBPACK FOOTER //
// src/routes/route-atlas.vue